module.exports={
  "filterList": "Filter list...",
  "applyToBothMaps": "Apply to both maps",
  "areYouSureYouWantToChooseVariable": "Are you sure you want to choose variable from different survey?  This action will remove all data filters from the map.",
  "gettingCurrentData": "Getting current data",
  "gettingDataCategoryDetails": "Getting data category details",
  "gettingMetadata": "Getting metadata",
  "searchForVariables": "Search for variables"
}
